import React from 'react'
import { useNavigate } from 'react-router-dom'

export const TemplateCardSmall = ({
  path,
  title,
  description,
}: {
  path: string
  title: string
  description: string
}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(path)
  }

  return (
    <div className='flex flex-col p-5 bg-white'>
      <button
        onClick={handleClick}
        className='text-left flex flex-col tracking-wide cursor-pointer rounded-3xl shadow-equal-all-sides
                   h-[260px] p-4'
      >
        <h3 className='font-medium text-[#1C7D93]'>{title}</h3>

        <hr className='my-[16px]' />

        <p className='h-full overflow-auto text-sm text-[#001A3D] text-justify'>
          {description}
        </p>

        <span className='flex flex-col items-end text-xs md:text-base hover:text-[#6596D7] font-medium pt-2'>
          Buy template
        </span>
      </button>
    </div>
  )
}
